import { makeOptionallyAuthenticatedQuery } from '@b-stock/fe-core/bstock-next/queries'
import { buildAxiosRequestConfig } from '@b-stock/fe-core/bstock-react'
import type { EuRunningTaxEstimateDto } from '@b-stock/listing-api-client'

import getEuTaxClient from './getEuTaxClient'

// Public running-estimate endpoint. The server may answer
// `{ estimateUnavailable: true }` — treat that as the fail-closed state
// (FR-020) rather than a zero. `rate` is returned as a 5dp decimal
// string so the caller can recompute `amount × rate` locally without
// re-hitting the endpoint per keystroke (FR-007).
const fetchEuRunningTaxEstimate = async (
  accessToken: string | null,
  listingId: string,
  buyerAddressId: string | undefined,
  buyerFeeCents: number | undefined,
  shippingCents: number | undefined
): Promise<EuRunningTaxEstimateDto> => {
  const client = getEuTaxClient()
  const config = buildAxiosRequestConfig({ accessToken })
  const { data } = await client.getEuRunningTaxEstimate(
    { listingId, buyerAddressId, buyerFeeCents, shippingCents },
    config
  )
  return data
}

const euTaxRunningEstimateQuery = makeOptionallyAuthenticatedQuery(
  'euTaxRunningEstimate',
  fetchEuRunningTaxEstimate
)

export default euTaxRunningEstimateQuery
